const BookingFilters = ({ onChange }) => {
 return (
 <div style={{ marginBottom: "15px" }}>
 <select
 onChange={(e) =>
 onChange({
 canceled:
 e.target.value === ""
 ? null
 : e.target.value === "true",
 })
 }
 >
 <option value="">All</option>
 <option value="false">Active</option>
 <option value="true">Canceled</option>
 </select>
 </div>
 );
};

export default BookingFilters;
